// Internal Dependencies:
import { loop } from 'utilities/objects'
import { loopArray } from 'utilities/arrays'

const initialState = {
	receivedTickets: false,
	ticketsById: {},
	ticketsCount: 0,
	ticketsMaxPages: 0,
	initialReceivedTicketsCount: false,
	notificationsByTicketId: {},
	isLoadingInternalNotes: false,
	isLoadingPublicAttachments: false,
	isDeletingPublicAttachment: false,
	updateState: 1
}

export default function reducer( state = initialState, action ) {
	const { payload } = action
	let ticketsById = {},
		ticketsByIdB = {},
		notificationsByTicketId = {},
		_

	switch ( action.type ) {
		case 'RECEIVE_TICKETS':
			loop( payload.items, ( key, item ) => {
				{ loopArray( item.comments, ( commentKey, comment ) => {
					if ( ! comment.is_seen_by_me ) {
						if ( ! notificationsByTicketId[ key ] ) {
							notificationsByTicketId[ key ] = []
						}

						notificationsByTicketId[ key ].push( comment )
					}
				} ) }
			} )

			let initialReceivedTicketsCount = state.initialReceivedTicketsCount

			if ( ! state.receivedTickets ) {
				initialReceivedTicketsCount = payload.count
			}

			return {
				...state,
				receivedTickets: true,
				ticketsById: payload.items,
				ticketsCount: payload.count,
				ticketsMaxPages: payload.max_pages,
				initialReceivedTicketsCount,
				notificationsByTicketId
			}

		case 'REMOVE_TICKET':
			const { [ `id_${payload}` ]: _, ...ticketsById } = state.ticketsById

			return {
				...state,
				ticketsById
			}

		case 'CLOSE_TICKET':
			ticketsByIdB = {
				...state.ticketsById
			}

			if ( ticketsByIdB[ `id_${payload}` ] ) {
				ticketsByIdB[ `id_${payload}` ].status = 'resolved'
			}

			return {
				...state,
				ticketsById: ticketsByIdB
			}

		case 'RECEIVE_TICKET_MESSAGE':
			return {
				...state,
				ticketsById: {
					...state.ticketsById,
					[ `id_${payload.ticketId}` ]: {
						...state.ticketsById[ `id_${payload.ticketId}` ],
						comments: [
							...state.ticketsById[ `id_${payload.ticketId}` ].comments,
							{
								user_id: payload.userID,
								name: payload.userName,
								content: payload.message
							}
						]
					}
				}
			}

		case 'LOADING_INTERAL_NOTES':
			return {
				...state,
				isLoadingInternalNotes: true
			}

		case 'RECEIVE_INTERAL_NOTES':
			return {
				...state,
				ticketsById: {
					...state.ticketsById,
					[ `id_${payload.ticketId}` ]: {
						...state.ticketsById[ `id_${payload.ticketId}` ],
						internal_notes_attachments: payload.data.internal_notes_attachments
					}
				},
				isLoadingInternalNotes: false,
				updateState: state.updateState + 1
			}

		case 'LOADING_PUBLIC_ATTACHMENTS':
			return {
				...state,
				isLoadingPublicAttachments: true
			}

		case 'DELETING_PUBLIC_ATTACHMENT':
			return {
				...state,
				isDeletingPublicAttachment: payload
			}

		case 'RECEIVE_PUBLIC_ATTACHMENTS':
			return {
				...state,
				ticketsById: {
					...state.ticketsById,
					[ `id_${payload.ticketId}` ]: {
						...state.ticketsById[ `id_${payload.ticketId}` ],
						attachments: payload.data.attachments
					}
				},
				isLoadingPublicAttachments: false,
				updateState: state.updateState + 1
			}
	}

	return state
}
